/**
 * File type filter constants shared by core state and file library UI.
 */

export type FileType = 'image' | 'document' | 'video' | 'audio' | 'archive' | 'all';

export const FILE_TYPE_FILTER_VALUES: Exclude<FileType, 'all'>[] = ['image', 'video', 'audio', 'document', 'archive'];

/**
 * Maps the file type filter to a list of extensions.
 */
export function getExtensionsForFileType(fileType: FileType): string[] | undefined {
	switch (fileType) {
		case 'image':
			return ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'];
		case 'document':
			return ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'md', 'rtf'];
		case 'video':
			return ['mp4', 'avi', 'mov', 'wmv', 'webm'];
		case 'audio':
			return ['mp3', 'wav', 'ogg', 'flac'];
		case 'archive':
			return ['zip', 'rar', '7z', 'tar', 'gz'];
		case 'all':
		default:
			return undefined;
	}
}
